import { fetchData } from "."
import { DeliveryStatus } from "./deliveries"

const MODULE_PATH = "/dashboard"

export default {
  getCounts(): Promise<Counts> {
    const url = `${MODULE_PATH}/Counts`
    return fetchData<Counts>(url)
  }
}

export interface Counts {
  totalUsers: number
  totalStores: number
  totalDrivers: number
  totalDeliveries: number
  deliveries: Record<DeliveryStatus, number>
}
